module.exports = __webpack_public_path__ + "static/media/htr1.4bf2093b.jpg";